export class TakeSnapshotResponse {
    'jobId';
    'snapshotId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return TakeSnapshotResponse.attributeTypeMap;
    }
    constructor() {
    }
}
